<template>
  <section>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              Home
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="HomeIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item active>
                  All Web Sites
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="3"
        cols="12"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary" @click="add_website">
          Add a new web site
        </b-button>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col lg="12">
        <all-sites/>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import emitter from '@core/utils/emitter'
import { reload } from '@/libs/boot'
import AllSites from './components/AllSites.vue'

export default {
  components: {
    AllSites
  },
  methods: {
    add_website() {
      this.$router.push('/all-web-sites/website/store')
    }
  },
  mounted() {
    emitter.on('change_calendar', reload)
  },
  beforeDestroy() {
    emitter.off('change_calendar', reload)
  }
}
</script>
